import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MpsApiService {
  private readonly _http = inject(HttpClient);

  constructor(@Inject('API_BASE_URL') private readonly _baseUrl: string) {}

  private buildUrl(resource: string): string {
    const base = this._baseUrl.endsWith('/') ? this._baseUrl.slice(0, -1) : this._baseUrl;
    const path = resource.startsWith('/') ? resource : '/' + resource;
    return base + path;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T>(resource: string, params: any = {}): Observable<T> {
    params.headers = new HttpHeaders({
      'Accept-Language': 'fr, en',
    });

    return this._http.get<T>(this.buildUrl(resource), params).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<T, TResponse>(resource: string, params?: T, options: any = {}): Observable<TResponse> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    return this._http.post<T>(this.buildUrl(resource), params, options).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch<T, TResponse>(resource: string, params?: T, options: any = {}): Observable<TResponse> {
    return this._http.patch<T>(this.buildUrl(resource), params, options).pipe(catchError(this.handleError));
  }

  delete<T>(resource: string, params?: object): Observable<T> {
    return this._http.delete<T>(this.buildUrl(resource), params).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadFile<T>(resource: string, file: File, options: any = {}): Observable<T> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    const formData = new FormData();
    formData.append('file', file);
    return this._http.post<T>(this.buildUrl(resource), formData, options).pipe(catchError(this.handleError));
  }

  getFile<T>(resource: string): Observable<T> {
    const httpOptions: object = { responseType: 'blob' };

    return this._http.get<T>(this.buildUrl(resource), httpOptions).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleError(error: any): Promise<any> {
    if (error.status === 401) {
      return Promise.reject(error);
    }
    if (error.status === 422) {
      return Promise.reject(error.error.message || error.message || error);
    }
    return Promise.reject(error.error.message || error.message || error);
  }
}
